<template>
  <div class="quiz__wrapper">
    <div class="quiz">
      <p class="quiz__intro">{{ questions.length }} x</p>
      <h3 class="quiz__title">{{ labels.quiz.title }}</h3>
      <template v-for="(question, index) in questions">
        <single
          v-if="question.type === 'single'"
          :key="index"
          v-bind="question"
          :index="index"
          @updateAnswer="updatedAnswer"
          class="quiz__question"
        />
        <multiple
          v-else-if="question.type === 'multiple'"
          :key="index"
          :index="index"
          v-bind="question"
          @updateAnswer="updatedAnswer"
          class="quiz__question"
        />
      </template>
    </div>
    <text-balloon
      :speed="4.2"
      class="quiz__invader"
      :isPaused="false"
      :fill="invaderColor"
      :text="scoreLabel"
      :text-background="scoreLabelColor"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { vuexGetters } from "../store";
import Single from "./Questions/Single.vue";
import Multiple from "./Questions/Multiple.vue";
import TextBalloon from "./TextBalloon.vue";

export default {
  name: "Quiz",
  data() {
    return {
      answersCorrect: [undefined, undefined, undefined],
      invaderColor: "#ab90c9",
      hasFinishedQuiz: false,
      noCorrectAnswers: 0,
      scoreLabel: "",
      scoreLabelColor: ""
    };
  },
  components: {
    Single,
    Multiple,
    TextBalloon
  },
  computed: {
    ...mapGetters({
      labels: vuexGetters.I18N
    }),
    questions() {
      return this.labels.quiz.questions;
    },
    scoreValues() {
      return this.labels.quiz.scoreValues;
    }
  },
  methods: {
    updatedAnswer({ index, value }) {
      this.answersCorrect[index] = value;
      if (
        this.answersCorrect.filter(answer => answer === undefined).length === 0
      ) {
        this.hasFinishedQuiz = true;
      }
      this.updateCorrectAnswers();
      this.updateInvaderColor();
    },
    updateInvaderColor() {
      let color = "#ab90c9";
      this.scoreLabel = "";
      if (this.hasFinishedQuiz) {
        this.scoreLabel =
          this.scoreValues[this.noCorrectAnswers] || this.scoreValues[0];
        switch (this.noCorrectAnswers) {
          case 3:
            color = "#81C747";
            break;
          case 2:
            color = "#FFCA00";
            break;
          case 1:
            color = "#EE2E5D";
            break;
          default:
            color = "#000000";
            break;
        }
      }
      this.invaderColor = color;
      this.scoreLabelColor = color;
    },
    updateCorrectAnswers() {
      this.noCorrectAnswers = this.answersCorrect.filter(
        isCorrect => !!isCorrect
      ).length;
    }
  }
};
</script>

<style lang="scss" scoped>
.quiz {
  background-color: rgba($french-gray, 0.3);
  border-radius: 18px;
  color: $eminence;
  display: block;
  margin: 0 25px;
  padding: 30px 10px;
  text-align: center;

  @media screen and (min-width: 714px) {
    padding: 32px 85px 65px;
    text-align: left;
  }

  &__wrapper {
    @media screen and (min-width: 714px) {
      box-sizing: border-box;
      max-width: 664px;
      margin: 0 auto;
    }
  }

  &__intro {
    color: $eminence;
    font-size: 1.0625rem;
    font-weight: 700;
    line-height: 1.5rem;
    @media screen and (min-width: 714px) {
      display: inline-block;
      font-size: 1.75rem;
      font-weight: 300;
      margin-right: 5px;
    }
  }

  &__title {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.125rem;
    @media screen and (min-width: 714px) {
      display: inline-block;
    }
  }

  &__invader {
    margin-top: 25px;
  }

  &__question:not(:last-child) {
    border-bottom: 2px solid $eminence;
    padding-bottom: 38px;
  }
}
</style>